var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticStyle: { width: "140px", height: "40px" },
      attrs: { src: require("./static/inter_city_order/trip_logo.png") },
    }),
    _c(
      "div",
      {},
      [
        _c("div", { staticClass: "flex-center font-24 margin-y-15" }, [
          _vm._v("云滴出行 —— 电子行程单"),
        ]),
        _c(
          "div",
          { staticClass: "flex-between margin-bottom-10" },
          [
            _c(
              "el-descriptions",
              { attrs: { title: "", column: 2, size: "mini" } },
              [
                _c("el-descriptions-item", { attrs: { label: "申请日期" } }, [
                  _vm._v(_vm._s(_vm.item.applyDate)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "行程时间" } }, [
                  _vm._v(
                    _vm._s(_vm.item.travelTimeStart) +
                      " 至 " +
                      _vm._s(_vm.item.travelTimeEnd)
                  ),
                ]),
                _c(
                  "el-descriptions-item",
                  { attrs: { label: "开票人手机号" } },
                  [_vm._v(_vm._s(_vm.item.mobile))]
                ),
                _c(
                  "el-descriptions-item",
                  { attrs: { label: "共" + _vm.item.travelNumb + "笔行程" } },
                  [_vm._v(_vm._s(_vm.item.amountTotal) + "元")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.item.itineraryMsg, border: "", size: "mini" },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: "序号",
                type: "index",
                width: "50",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "departTime",
                label: "出发时间",
                width: "180",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "startAdd",
                label: "起点",
                width: "180",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "endAdd", label: "终点", align: "center" },
            }),
            _c("el-table-column", {
              attrs: { prop: "passengerMsg", label: "乘车人", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "payAmount",
                label: "金额（元）",
                width: "100",
                align: "center",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }